export const convertModel = <T>(listing: any, dummyDto: any): T => {
    const dtoKeys = Object.keys(dummyDto);

    return Object.fromEntries(
        Object.entries(listing || {})
            .filter(([key]) => dtoKeys.includes(key))
    ) as T;
};
